var getNumberWithComma = function (stringNumber, chunkSize) {
    if (stringNumber.length <= chunkSize) {
        return stringNumber;
    }
    else {
        return stringNumber.replace(new RegExp("\\B(?=(\\d{" + chunkSize + "})+(?!\\d))", "g"), ",");
    }
};
var getNumberChunks = function (stringNumber, chunkSize) {
    return getNumberWithComma(stringNumber, chunkSize).split(",");
};
var getAbsoluteNumber = function (nativeNumber) {
    return {
        absoluteNumber: Math.abs(nativeNumber),
        isNegative: nativeNumber < 0,
    };
};

// https://ko.wiktionary.org/wiki/%EB%B6%80%EB%A1%9D:%EC%98%81%EC%96%B4_%EC%88%98%EC%82%AC
var numerals = [
    ["", "일", "이", "삼", "사", "오", "육", "칠", "팔", "구"],
    ["", "십", "백", "천"],
    ["", "만", "억", "조"],
];
var convertKorean = function (nativeNumber, option) {
    var _a = getAbsoluteNumber(nativeNumber), absoluteNumber = _a.absoluteNumber, isNegative = _a.isNegative;
    var chunks = getNumberChunks(absoluteNumber.toString(), 4);
    var reverseChunks = chunks
        .reverse()
        .map(function (chunk) { return chunk.split("").reverse(); });
    var koreanChunks = [];
    if (option.includes("MIXED")) {
        koreanChunks = reverseChunks
            .map(function (reverseChunk, index) {
            reverseChunk.unshift(numerals[2][index]);
            reverseChunk.reverse();
            return option.includes("COMMA")
                ? getNumberWithComma(reverseChunk.join(""), 3)
                : reverseChunk.join("");
        })
            .reverse();
    }
    else {
        koreanChunks = reverseChunks
            .map(function (reverseChunk, index) {
            var reverseKoreanChunk = reverseChunk.map(function (element, position) {
                return Number(element)
                    ? "" + numerals[0][Number(element)] + numerals[1][position]
                    : "";
            });
            reverseKoreanChunk.unshift(numerals[2][index]);
            return reverseKoreanChunk.reverse().join("");
        })
            .reverse();
    }
    isNegative && koreanChunks.unshift("-");
    return koreanChunks.join(option.includes("SPACE") ? " " : "");
};

var validateEmpty = function (input) {
    if (input === "") {
        throw new Error("please check the input is empty string");
    }
    if (input === ",") {
        throw new Error("please check the input has only one character : comma");
    }
};
function escapeRegExp(inputString) {
    // https://developer.mozilla.org/ko/docs/Web/JavaScript/Guide/Regular_Expressions
    return inputString.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}
var validateInteger = function (input) {
    if (typeof input === "number" && !Number.isInteger(input)) {
        throw new Error("please check the input is float");
    }
    if (typeof input === "string" &&
        !/^-?(1|2|3|4|5|6|7|8|9|0|,)+$/g.test(input)) {
        throw new Error("please check the input has characters except for -?(0|1|2|3|4|5|6|7|8|9|0|,)");
    }
};
// type: "korean" | "english" | "digit" | "notation" | "refinement"
var getNativeNumber = function (input) {
    validateEmpty(input);
    validateInteger(input);
    return Number(("" + input).replace(/,/g, "")) || 0;
};
var getKoreanNumber = function (input, option) {
    return convertKorean(getNativeNumber(input), option);
};

export { escapeRegExp, getKoreanNumber, getNativeNumber, validateEmpty, validateInteger };
//# sourceMappingURL=index.es.js.map
